module.exports = __webpack_public_path__ + "static/img/24.30eda97e.png";